var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 15.1L16.4 8.05L15 6.65L9.35 12.3L6.5 9.45L5.1 10.85L9.35 15.1ZM10.75 20.5C9.36667 20.5 8.06667 20.2375 6.85 19.7125C5.63333 19.1875 4.575 18.475 3.675 17.575C2.775 16.675 2.0625 15.6167 1.5375 14.4C1.0125 13.1833 0.75 11.8833 0.75 10.5C0.75 9.11667 1.0125 7.81667 1.5375 6.6C2.0625 5.38333 2.775 4.325 3.675 3.425C4.575 2.525 5.63333 1.8125 6.85 1.2875C8.06667 0.7625 9.36667 0.5 10.75 0.5C12.1333 0.5 13.4333 0.7625 14.65 1.2875C15.8667 1.8125 16.925 2.525 17.825 3.425C18.725 4.325 19.4375 5.38333 19.9625 6.6C20.4875 7.81667 20.75 9.11667 20.75 10.5C20.75 11.8833 20.4875 13.1833 19.9625 14.4C19.4375 15.6167 18.725 16.675 17.825 17.575C16.925 18.475 15.8667 19.1875 14.65 19.7125C13.4333 20.2375 12.1333 20.5 10.75 20.5ZM10.75 18.5C12.9833 18.5 14.875 17.725 16.425 16.175C17.975 14.625 18.75 12.7333 18.75 10.5C18.75 8.26667 17.975 6.375 16.425 4.825C14.875 3.275 12.9833 2.5 10.75 2.5C8.51667 2.5 6.625 3.275 5.075 4.825C3.525 6.375 2.75 8.26667 2.75 10.5C2.75 12.7333 3.525 14.625 5.075 16.175C6.625 17.725 8.51667 18.5 10.75 18.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.aa4dec41.svg";
export { ForwardRef as ReactComponent };